module.exports = __webpack_public_path__ + "js/4.55d09a23.worker.js"